import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface ColorPickerUniDriver extends BaseUniDriver {
  confirm: () => Promise<void>;
  cancel: () => Promise<void>;
  clickOnPreviousColor: () => Promise<void>;
  historyPanelExists: () => Promise<boolean>;
  historyCurrentColor: () => Promise<string>;
  historyPreviousColor: () => Promise<string>;
  clickAddColor: () => Promise<void>;
  selectRgbTab: () => Promise<void>;
  selectHsbTab: () => Promise<void>;
}
